import styled from "styled-components";

const CardImageStyle = styled.img`
  width: 100%;
  height: 350px;
  object-fit: cover;
  padding-bottom: 10px;
  border-radius: 8px;
`;

export default CardImageStyle;
